<app-home-custom-top-header *ngIf="!checkRoute && isUserLoggedIn"></app-home-custom-top-header>
<app-home-top-header *ngIf="!isUserLoggedIn && !checkRoute"></app-home-top-header>
<app-comman-header *ngIf="!checkRoute"></app-comman-header>
<app-contact-us-sub-header></app-contact-us-sub-header>

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card card-custom gutter-b card-stretch">
                <div class="card-body">
                    <app-contact-us-details></app-contact-us-details>
                </div>
            </div>
        </div>
    </div>
</div>
